import classnames from "classnames";
import * as PropTypes from "prop-types";
import React from "react";

import { Text } from "@krea/common/shared-components/text";

const FieldRequestPreviewHeader = ({
  className,
  label,
  value,
  empty,
  subheader,
}) => {
  return (
    <dl className={classnames("mb-0", { "mt-3 pl-5": subheader }, className)}>
      <Text
        htmlTag="dt"
        size={!subheader ? "md" : "sm"}
        className="text-gray-dark font-weight-bold pr-11 mb-1"
      >
        {label}
      </Text>
      <Text htmlTag="dd" className="m-0 font-weight-bold">
        {!empty ? value : "-"}
      </Text>
    </dl>
  );
};

FieldRequestPreviewHeader.propTypes = {
  label: PropTypes.node,
  value: PropTypes.node,
  empty: PropTypes.bool,
  subheader: PropTypes.bool,
};

export default FieldRequestPreviewHeader;
